import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=5dd7edba&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=5dd7edba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd7edba",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FooterSocial: require('/var/www/linza-front/linza-front-20251114081013/components/common/footer/FooterSocial.vue').default})
